import React, { useEffect } from "react";
import { Formik, Field, Form } from "formik";
import { fetchAPI } from "@/utility/NetworkUtils";
import { Button, TextField, Checkbox, FormControlLabel} from "@mui/material";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Check } from "@mui/icons-material";
import { getTheme } from "./LoginTheme";
const LoginForm = (props) => {

  const theme = getTheme();

  return (
    <ThemeProvider theme={theme}>
    <div>
      <div class="field">
        <TextField
          id="user_email"
          name="user[email]"
          type="email"
          autoComplete="email"
          fullWidth
          label="Email"
          margin="normal"
          variant="outlined"
        />
      </div>
      <div class="field">
        <TextField
          id="user_password"
          name="user[password]"
          type="password"
          autoComplete="current-password"
          fullWidth
          label="Password"
          margin="normal"
          variant="outlined"
        />
      </div>
      <div class="field">
        <FormControlLabel control={<Checkbox 
          name="user[remember_me]"
          color="primary"
          label="Remember me"
        />} label="Remember me" />
      </div>
      <div class="actions">
        <Button
          type="submit"
          fullWidth
          variant="contained"
          className="mb-4"
          color="green"
        >
          Log in
        </Button>
        <br/>
        <br/>
      </div>
    </div>
    </ThemeProvider>
  )
}

export default LoginForm